export function setupTextExpanders() {
    let expanders = Array.prototype.slice.call(document.querySelectorAll('.wysiwyg-expand-btn'));
    expanders.forEach(expander => {
        let expandText = expander.getAttribute('data-show-btn');
        let collapseText = expander.getAttribute('data-hide-btn');
        expander.innerHTML = expandText;
        let block = expander.parentNode.previousElementSibling;
        expander.addEventListener('click', e => {
            if (block.classList.contains('open') || block.classList.contains('closed')) {
                block.classList.toggle('closed');
                block.classList.toggle('open');
            }
            else {
                block.classList.add('open');
            }
            if (block.classList.contains('open')) {
                expander.innerHTML = collapseText;
            }
            else {
                expander.innerHTML = expandText;
            }
        })
    })
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/expand-text.ts